import { AxiosResponse } from "axios";
import { WorkorderItem } from "../types/workorderItem";
import { aplClient } from "./apiClient";

const getWorkorderItemsByWorkorder = (siteId: number, workorder: string) => {
    let dataUrl = `workorderitems/${siteId}/${workorder}`;
    return aplClient().get(dataUrl);
};

const getWorkorderItemsByDepartmentAndDate = (departmentId: number, lineId: number, dStartString: string, dEndString: string, closed: boolean) => {
    let dataUrl = `workorderitems/bydepartmentdate/${departmentId}/${lineId}/${dStartString}/${dEndString}/${closed ? "closed" : "open"}`;
    return aplClient().get(dataUrl);
};

const getWorkorderItemsByLineId = (lineId: number): Promise<AxiosResponse<WorkorderItem[], any>> => {
    let dataUrl = `workorderitems/bylineid/${lineId}`;
    return aplClient().get(dataUrl);
};



export { getWorkorderItemsByWorkorder, getWorkorderItemsByDepartmentAndDate, getWorkorderItemsByLineId };
